import React from 'react';

import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminCategoryCard.css';

const AdminCategoryCard = ({
  categoryWithPostCount,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const categoryFields = [
    { label: 'Name:', value: categoryWithPostCount.name, type: 'text' },
    {
      label: 'Description:',
      value: categoryWithPostCount.description,
      type: 'textarea',
    },
    {
      label: 'Show on Blog Side Bar:',
      value: categoryWithPostCount.showOnBlogSideBar,
      type: 'checkbox',
    },
  ];

  return (
    <div className='admin-blog-category-card-container'>
      <div className='admin-blog-category-top-container'>
        <span>{`Post count: ${categoryWithPostCount.postCount}`}</span>
        <div
          className='admin-blog-category-edit-delete-button-container'
          style={{ marginTop: '0px' }}
        >
          <ContentChangeButton
            iconType='edit'
            onClickHandler={() => onEditClickHandler(categoryWithPostCount)}
          />
          <ContentChangeButton
            iconType='delete'
            onClickHandler={() => onDeleteClickHandler(categoryWithPostCount)}
            isDisabled={categoryWithPostCount.postCount > 0}
            disabledMsg={`Cannot delete category that is still associated with blog posts`}
          />
        </div>
      </div>
      <div className='admin-blog-category-content-container'>
        <div className='admin-blog-category-group'>
          <div className='admin-blog-category-fields-container'>
            {categoryFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCategoryCard;
